import {Component, OnInit} from '@angular/core';
import {JourneyService} from '../service/journey.service';
import {ProgramDelegateModel} from '../models/program.model';
import {ActivatedRoute} from '@angular/router';
import {AnalyticsService} from '../../../services/analytics.service';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'app-manager-journey-page',
    templateUrl: './journey-diary-page.component.html',
    styleUrls: ['./journey-diary-page.component.scss'],
})
export class JourneyDiaryPage implements OnInit {

    pageData: ProgramDelegateModel = null;
    pDelegateId = 0;

    saveForm = false;

    constructor(
        private journeyService: JourneyService,
        private activatedRoute: ActivatedRoute,
        private analytics: AnalyticsService,
        public userService: UserService,
    ) {
    }

    ngOnInit() {
        this.pDelegateId = Number(this.activatedRoute.snapshot.paramMap.get('pDelegateId'));
        this.journeyService.getUserDiary(this.pDelegateId)
            .then(data => {
                this.pageData = data;
            });
    }

    ionViewDidEnter() {
        this.analytics.trackView('Learner Diary');
    }

    onSave() {
        this.saveForm = false;
        setTimeout(() => {
            this.saveForm = true;
        });
    }
}
